import { useState, useCallback } from "react";
import type { Job } from "providers/HostedScrapingProvider";
import scraperApi from "api";
import Spinner from "components/Spinner";
import { hasResult } from "components/hosted-scraping/job-list/utils";

export const DeliveryButton = ({job, projectId}: {job: Job, projectId: number}) => {
  const [ sendingInProgress, setSendingInProgress ] = useState(false);

  const resendFn = useCallback(async() => {
    setSendingInProgress(true);
    try {
      await scraperApi.hostedScraping.resendJobResult(projectId, job.id);
    } finally {
      setSendingInProgress(false);
    }
  }, [job.id, projectId])

  if (job.status === 'running') {
    return <span>-</span>;
  } else if (job.result?.webhook) {
    return (<div className="flex flex-wrap gap-2">
      <span>Webhook</span>
      { sendingInProgress
        ? (<Spinner className="w-5 h-5 mr-2 animate-spin" />)
        : (<button onClick={resendFn}>- <span className="text-brandPrimary dark:text-primary-600">Resend</span></button>)
      }
    </div>);
  } else if (hasResult(job)) {
    return (<span>Download</span>);
  } else {
    return <span>No result</span>;
  }
}
